import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GuestIdResolver implements Resolve<string | undefined> {
  constructor(private router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<string | undefined> | Promise<string | undefined> {
    const id = route.paramMap.get('id') ?? undefined;
    if (id && id.match(/^[0-9a-fA-F]{24}$/)) {
      localStorage.setItem('guestId', id as string);
    } else if (id) {
      localStorage.removeItem('guestId');
      this.router.navigate(['/authorization']);
    }
    return of(id);
  }
}
